import { ShieldX, Lock, AlertTriangle, Mail } from "lucide-react";

export const ZeroTrustDmarcKeyFindings = () => {
  const findings = [
    {
      icon: Lock,
      stat: "Strict",
      title: "Strict Alignment Is Now Mandatory",
      description: "Google and Yahoo's 2026 update requires identifier alignment between the RFC5322.From domain and the SPF/DKIM authentication domains. Relaxed alignment (subdomains) no longer qualifies.",
      color: "text-destructive",
      bgColor: "bg-destructive/10",
    },
    {
      icon: ShieldX,
      stat: "p=reject",
      title: "Reject Is the New Baseline",
      description: "DMARC policies of p=none or p=quarantine are insufficient. Major ISPs now expect p=reject as the minimum. Anything less and your emails may be rejected or marked as untrusted.",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
    {
      icon: AlertTriangle,
      stat: "95%",
      title: "Phishing Uses Spoofed Domains",
      description: "With 95% of phishing attacks using domain spoofing, ISPs have no tolerance for weak authentication. Zero-trust email means every message must prove its identity or be rejected.",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: Mail,
      stat: "100%",
      title: "All Sending Services Must Align",
      description: "Every service that sends email on your behalf—marketing platforms, CRMs, transactional services—must have aligned SPF and DKIM. One misconfigured service breaks your entire DMARC posture.",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        The Zero-Trust Email Paradigm
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        In 2026, email works on zero-trust principles: every message is suspicious until proven authentic. 
        DMARC enforcement is how you prove authenticity.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:border-destructive/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl ${finding.bgColor} flex items-center justify-center shrink-0`}>
                <finding.icon className={`w-6 h-6 ${finding.color}`} />
              </div>
              <div>
                <div className={`text-2xl font-bold ${finding.color} mb-1`}>{finding.stat}</div>
                <h3 className="font-semibold text-foreground mb-2">{finding.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};